import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FiChevronRight, FiArrowLeft } from "react-icons/fi";
import { GoArrowUpRight } from "react-icons/go";
import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";
import ContactUs from "../../component/contact-Us/ContactUs";
import HelpBlocks from "./helpBlocks";
import { getArticle } from "../../data/helpCenter";

const HelpArticle = () => {
  const { categorySlug, articleSlug } = useParams();
  const { category, article } = getArticle(categorySlug, articleSlug);
  const [isOpen, setIsOpen] = useState(false);

  if (!category || !article) {
    return (
      <>
        <div className="bg-white p-4 max-w-screen-2xl mx-auto">
          <Navbar />
          <div className="min-h-[50vh] flex flex-col items-center justify-center gap-4 mt-20">
            <h1 className="font-jakarta font-bold text-2xl">Article not found</h1>
            <Link to="/help" className="text-[#3AB1F6] font-inter font-medium underline">
              Back to Help Center
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const related = category.articles.filter((a) => a.slug !== article.slug).slice(0, 3);

  return (
    <>
      <div className="bg-white p-4 max-w-screen-2xl mx-auto flex flex-col gap-10">
        <Navbar />

        <div className="flex flex-col gap-8 mt-28 md:mt-36 lg:mx-[18%] md:mx-[8%] mx-[2%] w-auto">
          {/* Breadcrumb */}
          <nav className="flex flex-wrap items-center gap-2 font-inter text-[0.95rem] text-[#00000099]">
            <Link to="/help" className="hover:text-[#3AB1F6] transition-colors">
              Help Center
            </Link>
            <FiChevronRight className="size-4" />
            <Link
              to={`/help/topic/${category.slug}`}
              className="hover:text-[#3AB1F6] transition-colors"
            >
              {category.name}
            </Link>
            <FiChevronRight className="size-4" />
            <span className="text-black font-medium">{article.title}</span>
          </nav>

          {/* Header */}
          <div className="flex flex-col gap-3">
            <h1 className="font-jakarta font-bold xl:text-[2.8rem] lg:text-[2.4rem] text-[2rem] leading-tight">
              {article.title}
            </h1>
            {article.description && (
              <p className="font-inter font-medium xl:text-[1.35rem] text-[1.15rem] text-[#00000099]">
                {article.description}
              </p>
            )}
          </div>

          <hr className="border-[#0000000D]" />

          {/* Body */}
          <article>
            <HelpBlocks blocks={article.body} />
          </article>

          {/* Still need help */}
          <div className="mt-4 bg-[#EBF7FE] rounded-2xl p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="flex flex-col gap-1">
              <h3 className="font-jakarta font-semibold text-[1.35rem]">
                Still need help?
              </h3>
              <p className="font-inter text-[1.05rem] text-[#00000099]">
                Our support team is just a click away.
              </p>
            </div>
            <button
              onClick={() => setIsOpen(true)}
              className="w-max text-[0.95rem] group text-white font-semibold font-inter flex items-center gap-2 p-2 pl-5 rounded-full bg-[#3AB1F6]"
            >
              Contact Us
              <span className="bg-white text-[#3AB1F6] p-1.5 rounded-full group-hover:rotate-45 transition-all duration-200">
                <GoArrowUpRight className="size-4" />
              </span>
            </button>
          </div>

          {/* Related */}
          {related.length > 0 && (
            <div className="flex flex-col gap-4 mt-4">
              <h3 className="font-jakarta font-semibold text-[1.35rem]">
                More in {category.name}
              </h3>
              <div className="flex flex-col gap-3">
                {related.map((a) => (
                  <Link
                    key={a.slug}
                    to={`/help/topic/${category.slug}/${a.slug}`}
                    className="group flex items-center justify-between gap-3 border border-[#0000001A] rounded-xl px-5 py-4 hover:border-[#3AB1F6] transition-colors"
                  >
                    <span className="font-inter font-medium text-[1.05rem]">{a.title}</span>
                    <GoArrowUpRight className="flex-none size-4 text-[#3AB1F6] group-hover:rotate-45 transition-transform duration-200" />
                  </Link>
                ))}
              </div>
            </div>
          )}

          {/* Back link */}
          <Link
            to={`/help/topic/${category.slug}`}
            className="flex items-center gap-2 font-inter font-medium text-[#3AB1F6] w-max mt-2"
          >
            <FiArrowLeft className="size-4" /> Back to {category.name}
          </Link>
        </div>
      </div>
      <Footer />
      <ContactUs isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default HelpArticle;
